/**
 * Opzioni condivise di stato civile e stile alimentare.
 *
 * Modulo foglia: zero import. Lo consumano gli schemi Zod (client e,
 * tramite copia generata, le Cloud Functions) e, nel blocco UI, i menu
 * del wizard e del gestionale. Non importare da qui moduli del
 * gestionale o del portale.
 *
 * I valori sono il contratto persistito. Le label sono solo testo di UI.
 */

export const STATO_CIVILE_VALORI = [
  'Celibe/Nubile',
  'Sposato',
  'Divorziato',
  'Vedovo',
  'Altro',
] as const;

export type StatoCivile = (typeof STATO_CIVILE_VALORI)[number];

export const STATO_CIVILE_OPZIONI: ReadonlyArray<{
  value: StatoCivile;
  label: string;
}> = STATO_CIVILE_VALORI.map((value) => ({ value, label: value }));

export const STILE_ALIMENTARE_VALORI = [
  'onnivoro',
  'vegetariano',
  'vegano',
  'pescetariano',
  'flexitariano',
  'chetogenico',
  'mediterraneo',
  'altro',
] as const;

export type StileAlimentare = (typeof STILE_ALIMENTARE_VALORI)[number];

export const STILE_ALIMENTARE_OPZIONI: ReadonlyArray<{
  value: StileAlimentare;
  label: string;
}> = [
  { value: 'onnivoro', label: 'Onnivoro' },
  { value: 'vegetariano', label: 'Vegetariano' },
  { value: 'vegano', label: 'Vegano' },
  { value: 'pescetariano', label: 'Pescetariano' },
  { value: 'flexitariano', label: 'Flexitariano' },
  { value: 'chetogenico', label: 'Chetogenico' },
  { value: 'mediterraneo', label: 'Mediterraneo' },
  { value: 'altro', label: 'Altro' },
];
